function todayUtcString() {
  return new Date().toISOString().slice(0, 10);
}

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

function isValidDateString(s) {
  if (typeof s !== 'string') return false;
  const t = s.trim();
  return DATE_RE.test(t) && !Number.isNaN(Date.parse(t));
}

/**
 * @param {*} instructor - current user from auth (snake_case DB fields)
 * @param {function} t - i18next t bound to `admin.cert.*` keys via prefix in calls
 * @returns {string[]} human-readable issues in the active UI language, empty if pilot may edit availability
 */
export function getPilotCertificateBlockers(instructor, t) {
  if (!instructor || instructor.isAdmin) return [];
  const today = todayUtcString();
  const issues = [];
  const c = (key, opts) => t(`admin.cert.${key}`, opts);

  const licPath = (instructor.license_document_path || '').trim();
  if (!licPath) {
    issues.push(c('licenseDocMissing'));
  }

  const medPath = (instructor.medical_document_path || '').trim();
  if (!medPath) {
    issues.push(c('medicalDocMissing'));
  }

  const licUntil = (instructor.license_valid_until || '').trim();
  if (!licUntil) {
    issues.push(c('sepDateMissing'));
  } else if (!isValidDateString(licUntil)) {
    issues.push(c('sepDateInvalid'));
  } else if (licUntil < today) {
    issues.push(c('sepExpired', { date: licUntil }));
  }

  const medUntil = (instructor.medical_valid_until || '').trim();
  if (!medUntil) {
    issues.push(c('medicalDateMissing'));
  } else if (!isValidDateString(medUntil)) {
    issues.push(c('medicalDateInvalid'));
  } else if (medUntil < today) {
    issues.push(c('medicalExpired', { date: medUntil }));
  }

  return issues;
}
